import { useRouter as _useRouter } from 'next/navigation';

import { isMiniProgram } from '@whelk/utils';
export const useRouter = () => {
  const nav = _useRouter();
  const miniPush = (url: string) => {
    nav.push(url + window.location.hash);
  };
  const miniReplace = (url: string) => {
    nav.replace(url + window.location.hash);
  };

  return {
    ...nav,
    push: isMiniProgram ? miniPush : nav.push,
    replace: isMiniProgram ? miniReplace : nav.replace,
  };
};
